import { apiGet } from './client';
import type { Page } from '../types/Page';

export function getPages(): Promise<Page[]> {
  return apiGet<Page[]>('/api/pages');
}
